import * as React from 'react'
import type { SVGProps } from 'react'
function SvgMsKlimadashboardIconsKlimakenntageHeiss(
  props: SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      data-name="Ebene 1"
      viewBox="0 0 120.67 249.21"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <style>{'.kkt-icon-ht{fill:#f28443}'}</style>
      </defs>
      <g className="kkt-icon-ht" id="c">
        <path d="M97.67,157.02V27.65c0-15.25-12.4-27.65-27.65-27.65s-27.65,12.4-27.65,27.65v130.13c-14.73,10.06-23.01,27.15-21.72,45.07,1.8,24.93,21.21,44.37,46.13,46.22,1.29.1,2.58.14,3.86.14,12.69,0,24.65-4.68,34.02-13.38,10.17-9.45,16.01-22.82,16.01-36.7,0-16.99-8.76-32.94-23-42.12ZM99.9,230.71c-8.87,8.24-20.45,12.28-32.6,11.38-21.43-1.59-38.12-18.3-39.67-39.74-1.16-15.99,6.54-31.2,20.09-39.71,1.02-.64,1.64-1.76,1.64-2.96V27.65c0-11.39,9.26-20.65,20.65-20.65s20.65,9.26,20.65,20.65v131.32c0,1.24.66,2.39,1.73,3.02,13.12,7.72,21.27,21.95,21.27,37.15,0,11.94-5.02,23.44-13.77,31.57Z" />
        <path d="M73.93,174.7V22.5c0-1.93-1.57-3.5-3.5-3.5s-3.5,1.57-3.5,3.5v152.2c-11.66,1.7-20.65,11.76-20.65,23.89,0,13.31,10.83,24.15,24.15,24.15s24.15-10.83,24.15-24.15c0-12.12-8.98-22.19-20.65-23.89ZM70.43,215.73c-9.45,0-17.15-7.69-17.15-17.15s7.66-17.11,17.09-17.14c.02,0,.04,0,.06,0s.04,0,.06,0c9.43.03,17.09,7.71,17.09,17.14s-7.69,17.15-17.15,17.15Z" />
        <path d="M3.5,47.07h27.55c1.93,0,3.5-1.57,3.5-3.5s-1.57-3.5-3.5-3.5H3.5c-1.93,0-3.5,1.57-3.5,3.5s1.57,3.5,3.5,3.5Z" />
        <path d="M16.62,27.01h14.43c1.93,0,3.5-1.57,3.5-3.5s-1.57-3.5-3.5-3.5h-14.43c-1.93,0-3.5,1.57-3.5,3.5s1.57,3.5,3.5,3.5Z" />
        <path d="M31.05,60.12h-14.43c-1.93,0-3.5,1.57-3.5,3.5s1.57,3.5,3.5,3.5h14.43c1.93,0,3.5-1.57,3.5-3.5s-1.57-3.5-3.5-3.5Z" />
        <path d="M3.5,87.18h27.55c1.93,0,3.5-1.57,3.5-3.5s-1.57-3.5-3.5-3.5H3.5c-1.93,0-3.5,1.57-3.5,3.5s1.57,3.5,3.5,3.5Z" />
        <path d="M34.55,123.79c0-1.93-1.57-3.5-3.5-3.5H3.5c-1.93,0-3.5,1.57-3.5,3.5s1.57,3.5,3.5,3.5h27.55c1.93,0,3.5-1.57,3.5-3.5Z" />
        <path d="M31.05,100.23h-14.43c-1.93,0-3.5,1.57-3.5,3.5s1.57,3.5,3.5,3.5h14.43c1.93,0,3.5-1.57,3.5-3.5s-1.57-3.5-3.5-3.5Z" />
        <path d="M34.55,143.84c0-1.93-1.57-3.5-3.5-3.5h-14.43c-1.93,0-3.5,1.57-3.5,3.5s1.57,3.5,3.5,3.5h14.43c1.93,0,3.5-1.57,3.5-3.5Z" />
      </g>
    </svg>
  )
}
export default SvgMsKlimadashboardIconsKlimakenntageHeiss
